// import React from 'react';

// const services = [
//   {
//     title: 'For Students',
//     points: ['Career Planning', 'Subject Expertise', 'Mentoring', 'Skill Development'],
//   },
//   {
//     title: 'For Graduates',
//     points: ['Resume Building', 'Interview Prep', 'Career Counseling'],
//   },
//   {
//     title: 'For Professionals',
//     points: ['Leadership Training', 'Career Shifts', 'Soft Skills'],
//   },
// ];

// const Services = () => (
//   <section id="services" className="py-16 bg-gray-50">
//     <div className="container mx-auto text-center mb-10">
//       <h2 className="text-3xl font-bold text-blue-800">Our Services</h2>
//     </div>
//     <div className="flex flex-wrap justify-center gap-8">
//       {services.map(({ title, points }) => (
//         <div key={title} className="w-full md:w-1/3 bg-white p-6 rounded shadow-lg">
//           <h3 className="text-xl font-semibold text-blue-700 mb-4">{title}</h3>
//           <ul className="text-gray-700 space-y-2 list-disc list-inside">
//             {points.map((point, idx) => <li key={idx}>{point}</li>)}
//           </ul>
//         </div>
//       ))}
//     </div>
//   </section>
// );

// export default Services;
import React from "react";
import useInView from "../hooks/useInView";

// const items = [
//   {
//     title: "Career Planning",
//     desc: "Clarity from high school to professional tracks with actionable roadmaps.",
//     icon: "🎯",
//   },
//   {
//     title: "Corporate Training",
//     desc: "Practical workshops to sharpen in-demand skills and team effectiveness.",
//     icon: "🏢",
//   },
//   {
//     title: "Resume & Interviews",
//     desc: "ATS-friendly resumes, mock interviews, and portfolio reviews.",
//     icon: "📄",
//   },
//   {
//     title: "Mentoring Programs",
//     desc: "1:1 mentoring, progress tracking, and personalized growth plans.",
//     icon: "🧭",
//   },
// ];

export default function Services() {
  const { ref, inView } = useInView();

  return (
    <section id="services" >
      {/* <div className="mx-auto max-w-7xl px-4"> */}
        <div className={`reveal ${inView ? "in-view" : ""}`} ref={ref}>
          <section className="py-20 bg-gradient-to-br from-yellow-50 via-pink-50 to-blue-50">
  <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">Our Services</h2>
  <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">Structured guidance at every stage of your career journey — from school to professional growth.</p>
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto px-6">
    {[
      { 
        icon: "🎯", 
        title: "Systematic Career Planning (SCP)", 
        text: "Structured guidance similar to SIP (Systematic Investment Plan) — invest time in career planning for long-term success at every stage.",
      },
      { 
        icon: "📚", 
        title: "Career Guidance Programs", 
        text: "Stage-wise guidance: 8th Std awareness, 10th Std stream selection, 12th Std career path, and post-12th higher education planning.",
      },
      { 
        icon: "🤝", 
        title: "One-on-One Paid Consultation", 
        text: "Personalized sessions to understand your strengths, interests, and career options with dedicated industry expert mentors.",
      },
      { 
        icon: "🎓", 
        title: "Seminars & Workshops", 
        text: "Learn from industry experts — join sessions on Engineering, Medical, CA and more. Free webinars and interactive seminars available.",
        cta: true,
      },
      { 
        icon: "🔄", 
        title: "Career Switching Guidance", 
        text: "Helping professionals decide when and how to switch jobs, move to higher studies, or navigate career transitions confidently.",
      },
      { 
        icon: "🧭", 
        title: "Long-Term Mentorship Program", 
        text: "Ongoing mentorship with progress tracking, WhatsApp follow-ups, and personalized growth plans for sustained career development.",
      }
    ].map((items) => (
      <div key={items.title} className="bg-white/80 rounded-3xl p-8 shadow-lg hover:scale-105 transition cursor-pointer">
        <div className="text-5xl">{items.icon}</div>
        <h3 className="mt-4 text-xl font-semibold">{items.title}</h3>
        <p className="mt-2 text-gray-600 text-sm">{items.text}</p>
        {items.cta && (
          <a href="#contact" className="inline-block mt-4 px-5 py-2 rounded-full bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-700 hover:scale-105 transition">
            Register Now
          </a>
        )}
      </div>
    ))}
  </div>

  {/* Target Audience Sub-sections */}
  <div className="max-w-6xl mx-auto px-6 mt-16">
    <h3 className="text-2xl font-bold text-center mb-8 text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-pink-500">Who We Serve</h3>
    <div className="grid md:grid-cols-3 gap-8">
      {[
        {
          title: "For Students",
          items: ["Career Planning & Guidance", "Mentoring & Counseling", "Subject Expertise & Tutoring", "Technical & Soft Skills Development", "Extracurricular Enrichment"],
          color: "border-blue-400",
        },
        {
          title: "For Graduates & Job Seekers",
          items: ["Resume Building & Interview Prep", "Career Counseling & Guidance", "Skills Training & Certifications", "Internship & Work Experience", "Networking & Professional Growth"],
          color: "border-green-400",
        },
        {
          title: "For Working Professionals",
          items: ["Professional Development Programs", "Leadership & Management Training", "Career Transition Support", "Corporate & Group Training", "Continuing Education Guidance"],
          color: "border-purple-400",
        },
      ].map((group) => (
        <div key={group.title} className={`bg-white rounded-2xl p-6 shadow-md border-t-4 ${group.color}`}>
          <h4 className="text-lg font-bold mb-3">{group.title}</h4>
          <ul className="space-y-2 text-gray-600 text-sm">
            {group.items.map((item, i) => (
              <li key={i} className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </div>
</section>

        </div>

      {/* </div> */}
    </section>
  );
}
